// Equipment catalog — grouped by category, with brand attribution and product bullets.

export const EQUIPMENT_CATEGORIES = [
  {
    id: "radio-comms",
    icon: "Broadcast",
    brands: ["MOTOROLA", "HYTERA"],
    image: "/equipment/motorola-hytera-radios.jpg",
    accent: "rgba(220,38,38,0.12)",
    title: {
      pt: "Rádios & Repetidores",
      en: "Radios & Repeaters",
      es: "Radios y Repetidores",
    },
    desc: {
      pt: "Comunicações rádio profissionais MOTOROLA — portáteis, móveis e repetidores para operações críticas em campo.",
      en: "MOTOROLA professional radio communications — portables, mobiles and repeaters for mission-critical field operations.",
      es: "Comunicaciones de radio profesionales MOTOROLA — portátiles, móviles y repetidores para operaciones críticas.",
    },
    items: {
      pt: [
        "Rádios portáteis DMR / analógicos",
        "Rádios móveis para viaturas",
        "Repetidores de cobertura",
        "Repetidor DMR Hytera HR1065",
        "Antenas, acessórios e programação",
      ],
      en: [
        "DMR / analog portable radios",
        "Mobile radios for vehicles",
        "Coverage repeaters",
        "Hytera HR1065 DMR Repeater",
        "Antennas, accessories and programming",
      ],
      es: [
        "Radios portátiles DMR / analógicos",
        "Radios móviles para vehículos",
        "Repetidores de cobertura",
        "Repetidor DMR Hytera HR1065",
        "Antenas, accesorios y programación",
      ],
    },
  },
  {
    id: "pbx",
    icon: "Phone",
    brands: ["INTELBRAS", "CISCO", "ALCATEL"],
    image: "/equipment/pbx-phones-set.jpg",
    accent: "rgba(37,99,235,0.14)",
    title: {
      pt: "Centrais Telefónicas & Telefones",
      en: "PBX Systems & Phones",
      es: "Centralitas Telefónicas & Teléfonos",
    },
    desc: {
      pt: "Centrais INTELBRAS, CISCO e ALCATEL — híbridas, IP e analógicas, escaláveis para escritório, hotelaria e indústria.",
      en: "INTELBRAS, CISCO and ALCATEL PBX — hybrid, IP and analog, scalable for offices, hospitality and industry.",
      es: "Centralitas INTELBRAS, CISCO y ALCATEL — híbridas, IP y analógicas, escalables para oficinas, hotelería e industria.",
    },
    items: {
      pt: [
        "Centrais IP/híbridas INTELBRAS",
        "Centrais CISCO Unified Communications",
        "Centrais ALCATEL OmniPCX",
        "Telefones analógicos / digitais",
        "Telefones VoIP / IP",
        "Telefones GSM",
        "Telefones Wireless (DECT)",
        "Terminais IP e analógicos",
        "Configuração, DIDs e URA",
      ],
      en: [
        "INTELBRAS IP/hybrid PBX",
        "CISCO Unified Communications",
        "ALCATEL OmniPCX PBX",
        "Analog / digital phones",
        "VoIP / IP phones",
        "GSM phones",
        "Wireless phones (DECT)",
        "IP and analog handsets",
        "Configuration, DIDs and IVR",
      ],
      es: [
        "Centralitas IP/híbridas INTELBRAS",
        "CISCO Unified Communications",
        "Centralitas ALCATEL OmniPCX",
        "Teléfonos analógicos / digitales",
        "Teléfonos VoIP / IP",
        "Teléfonos GSM",
        "Teléfonos Wireless (DECT)",
        "Terminales IP y analógicos",
        "Configuración, DID e IVR",
      ],
    },
  },
  {
    id: "vsat",
    icon: "SatelliteDish",
    brands: ["VSAT"],
    image: "/equipment/vsat-ptp.jpg",
    accent: "rgba(14,165,233,0.14)",
    title: {
      pt: "VSAT & Comunicações Satélite",
      en: "VSAT & Satellite Comms",
      es: "VSAT & Comunicaciones Satélite",
    },
    desc: {
      pt: "Soluções VSAT chave-na-mão e telefones satélites para locais remotos onde a fibra ou o rádio não chegam.",
      en: "Turn-key VSAT solutions and satellite phones for remote sites where fiber or radio cannot reach.",
      es: "Soluciones VSAT llave en mano y teléfonos satelitales para sitios remotos donde la fibra o la radio no llegan.",
    },
    items: {
      pt: [
        "Antenas VSAT Banda C",
        "Antenas VSAT Ku / Ka",
        "Modems e iDirect",
        "Telefones satélite (Iridium/Thuraya)",
        "Links Ponto-a-Ponto (PtP)",
        "Projecto, licenciamento e monitorização",
      ],
      en: [
        "C-Band VSAT dishes",
        "Ku / Ka band VSAT dishes",
        "Modems and iDirect",
        "Satellite phones (Iridium/Thuraya)",
        "Point-to-Point (PtP) links",
        "Design, licensing and monitoring",
      ],
      es: [
        "Antenas VSAT Banda C",
        "Antenas VSAT Ku / Ka",
        "Módems e iDirect",
        "Teléfonos satelitales (Iridium/Thuraya)",
        "Enlaces Punto a Punto (PtP)",
        "Proyecto, licencias y monitorización",
      ],
    },
  },
  {
    id: "tv-dstv",
    icon: "Television",
    brands: ["DSTV"],
    image:
      "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?auto=format&fit=crop&w=1200&q=80",
    accent: "rgba(168,85,247,0.14)",
    title: {
      pt: "Monitores LED/LCD & Sistemas DSTV",
      en: "LED/LCD Monitors & DSTV Systems",
      es: "Monitores LED/LCD & Sistemas DSTV",
    },
    desc: {
      pt: "Monitores LED e LCD, parabólicas DSTV, receptores e distribuição de sinal TV para residências e condomínios.",
      en: "LED and LCD monitors, DSTV dishes, receivers and TV signal distribution for homes and condominiums.",
      es: "Monitores LED y LCD, parabólicas DSTV, receptores y distribución de señal TV para residencias y condominios.",
    },
    items: {
      pt: [
        "Monitores LED / LCD Full HD / 4K",
        "Parabólicas e LNBs DSTV",
        "Receptores DSTV Explora / HD",
        "Amplificadores, splitters e cablagem",
      ],
      en: [
        "Full HD / 4K LED / LCD monitors",
        "DSTV dishes and LNBs",
        "DSTV Explora / HD receivers",
        "Amplifiers, splitters and cabling",
      ],
      es: [
        "Monitores LED / LCD Full HD / 4K",
        "Parabólicas y LNBs DSTV",
        "Receptores DSTV Explora / HD",
        "Amplificadores, divisores y cableado",
      ],
    },
  },
  {
    id: "it",
    icon: "Desktop",
    brands: [],
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80",
    accent: "rgba(59,130,246,0.14)",
    title: {
      pt: "Computadores & Informática",
      en: "Computers & IT",
      es: "Computadoras & Informática",
    },
    desc: {
      pt: "Computadores, servidores e periféricos — fornecimento, configuração e garantia para empresas.",
      en: "Computers, servers and peripherals — supply, setup and warranty for businesses.",
      es: "Computadoras, servidores y periféricos — suministro, configuración y garantía para empresas.",
    },
    items: {
      pt: [
        "Desktops e portáteis",
        "Servidores e NAS",
        "Impressoras e periféricos",
        "Licenciamento e suporte",
      ],
      en: [
        "Desktops and laptops",
        "Servers and NAS",
        "Printers and peripherals",
        "Licensing and support",
      ],
      es: [
        "Escritorios y portátiles",
        "Servidores y NAS",
        "Impresoras y periféricos",
        "Licenciamiento y soporte",
      ],
    },
  },
  {
    id: "security",
    icon: "ShieldCheck",
    brands: [],
    image:
      "https://images.unsplash.com/photo-1557597774-9d273605dfa9?auto=format&fit=crop&w=1200&q=80",
    accent: "rgba(16,185,129,0.14)",
    title: {
      pt: "Vigilância & Segurança",
      en: "Surveillance & Security",
      es: "Vigilancia & Seguridad",
    },
    desc: {
      pt: "CCTV IP, controlo de acessos, alarmes e interfonia — projecto integrado para instalações críticas.",
      en: "IP CCTV, access control, alarms and intercom — integrated design for critical facilities.",
      es: "CCTV IP, control de accesos, alarmas e intercomunicación — diseño integrado para instalaciones críticas.",
    },
    items: {
      pt: [
        "Câmaras IP 2K/4K com analítica",
        "NVRs e videowalls",
        "Controlo de acessos (cartão / biometria)",
        "Alarmes e interfonia",
      ],
      en: [
        "2K/4K IP cameras with analytics",
        "NVRs and videowalls",
        "Access control (card / biometric)",
        "Alarms and intercom",
      ],
      es: [
        "Cámaras IP 2K/4K con analítica",
        "NVR y videowalls",
        "Control de acceso (tarjeta / biométrico)",
        "Alarmas e intercomunicación",
      ],
    },
  },
  {
    id: "networks",
    icon: "WifiHigh",
    brands: [],
    image:
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1200&q=80",
    accent: "rgba(99,102,241,0.14)",
    title: {
      pt: "Redes & Wireless",
      en: "Networks & Wireless",
      es: "Redes & Wireless",
    },
    desc: {
      pt: "Cablagem estruturada certificada, switching, Wi-Fi empresarial e links wireless ponto-a-ponto.",
      en: "Certified structured cabling, switching, enterprise Wi-Fi and point-to-point wireless links.",
      es: "Cableado estructurado certificado, switching, Wi-Fi empresarial y enlaces wireless punto a punto.",
    },
    items: {
      pt: [
        "Cablagem Cat. 6 / 6A e fibra óptica",
        "Switches, routers e firewall",
        "Wi-Fi empresarial (indoor/outdoor)",
        "Links PtP/PtMP de longa distância",
      ],
      en: [
        "Cat. 6 / 6A and fiber optic cabling",
        "Switches, routers and firewalls",
        "Enterprise Wi-Fi (indoor/outdoor)",
        "Long-range PtP/PtMP links",
      ],
      es: [
        "Cableado Cat. 6 / 6A y fibra óptica",
        "Switches, routers y firewalls",
        "Wi-Fi empresarial (interior/exterior)",
        "Enlaces PtP/PtMP de larga distancia",
      ],
    },
  },
];

export const equipmentStrings = {
  pt: {
    nav: "Equipamentos",
    overline: "Equipamentos · Catálogo",
    title: "Marcas de referência, entregues e assistidas em Angola.",
    subtitle:
      "Representamos, comercializamos e assistimos equipamentos de marcas internacionalmente fiáveis — da comunicação rádio à TV por satélite, passando por informática, segurança e redes.",
    stat_categories: "Categorias",
    stat_brands: "Marcas Representadas",
    stat_warranty: "Garantia Oficial",
    brands_title: "Marcas que representamos",
    items_title: "Inclui",
    cta_title: "Procura um equipamento específico?",
    cta_desc:
      "Envie-nos a descrição do que precisa — respondemos com disponibilidade, preço e prazo em horário comercial.",
    cta_btn: "Pedir orçamento",
  },
  en: {
    nav: "Equipment",
    overline: "Equipment · Catalog",
    title: "Reference brands, delivered and serviced in Angola.",
    subtitle:
      "We represent, sell and service equipment from internationally trusted brands — from radio communications to satellite TV, IT, security and networks.",
    stat_categories: "Categories",
    stat_brands: "Brands Represented",
    stat_warranty: "Official Warranty",
    brands_title: "Brands we represent",
    items_title: "Includes",
    cta_title: "Looking for a specific equipment?",
    cta_desc:
      "Send us what you need — we reply with availability, price and lead time during business hours.",
    cta_btn: "Request a quote",
  },
  es: {
    nav: "Equipos",
    overline: "Equipos · Catálogo",
    title: "Marcas de referencia, entregadas y con servicio en Angola.",
    subtitle:
      "Representamos, comercializamos y damos servicio a equipos de marcas internacionalmente fiables — desde radio a TV satelital, informática, seguridad y redes.",
    stat_categories: "Categorías",
    stat_brands: "Marcas Representadas",
    stat_warranty: "Garantía Oficial",
    brands_title: "Marcas que representamos",
    items_title: "Incluye",
    cta_title: "¿Buscas un equipo específico?",
    cta_desc:
      "Envíanos lo que necesitas — respondemos con disponibilidad, precio y plazo en horario comercial.",
    cta_btn: "Solicitar presupuesto",
  },
};
